<template>
  <header>
    <img v-responsive.xl src="@/assets/images/banners/banner-empleos-home-1680x1050.jpg" alt="" class="w-100">
    <img v-responsive.lg.md src="@/assets/images/banners/banner-empleos-home-1024x768.jpg" alt="" class="w-100">
    <img v-responsive.sm src="@/assets/images/banners/banner-empleos-home-768x1024.jpg" alt="" class="w-100">
    <img v-responsive.xs src="@/assets/images/banners/banner-empleos-home-500x750.jpg" alt="" class="w-100">
    <div class="hyper-link">
      <div class="content">
        <a href="#/empleos"  class="btn btn-lg shadow b-blue4 auto-ajust-font mx-2 px-5">
          Busca empleos
        </a>
      </div>
    </div>
  </header>
</template>
<style scoped lang="scss">

  .content {
    @media only screen and (min-width: 500px) {
      width: 100%;
      float: none;
      text-align: center;
    }
    @media only screen and (min-width: 544px) {
      width: 80vw;
      float: left;
      text-align: center;
    }
    @media only screen and (min-width: 767px) {
      width: 55vw;
      float: left;
      padding: 0 20px;
    }
    @media only screen and (min-width: 1200px) {
      width: 75vw;
      float: left;
      padding: 0 20px;
    }
  }

  /**
    hyper-link:
   */
  .hyper-link {
    position: absolute;
    width: 100%;
    right: 0;

    @media only screen and (min-width: 500px) {
      top: 65vw;
      .auto-ajust-font{
        font-size: 3.7vw;
      }
    }
    @media only screen and (min-width: 544px) {
      top: 55vw;
      .auto-ajust-font{
        font-size: 3vw;
      }
    }
    @media only screen and (min-width: 767px) {
      top: 38vw;
      .auto-ajust-font{
        font-size: 2vw;
      }
    }
    @media only screen and (min-width: 1200px) {
      top: 36vw;
      .auto-ajust-font{
        font-size: 1.2vw;
      }
    }
  }

  /**
    header and backgroundImage
   */
  header{
    width: 100%;
    height: 100%;
    @media only screen and (min-width: 992px) {
      height: 100vh;
      overflow: hidden;
    }
    img{
      width: 100%;
    }
  }

</style>
<script>
  export default {
    computed: {
      isLogin: function () {
        return this.$store.getters.isLoggedIn
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/#public/home/slider/onSession/Job.vue